import {useState, useEffect} from 'react'
import UserTable from './components/tables/usertable'
import SideMenu from './components/sidemenu/sidemenu'
import CategoryTable from './components/tables/categoryTable'
import SingleUserPage from './pages/singleuserPage'
import SetTable from './components/tables/setTable'
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom'
import LoginPage from './pages/loginPage'
import NavBar from './components/navbar/navBar'
import HomePage from './pages/homePage'
import StyleTable from './components/tables/styleTable'
import StylePage from './pages/stylePage'
import CreateStylePage from './pages/createPages/createStyle'
import PromptTable from './components/tables/promptTable'
import PromptPage from './pages/promptPage'
import CreatePromptPage from './pages/createPages/createPrompt'
import SingleSetPage from './pages/setPage'
import ModelTable from './components/tables/modelTable'
import SingleModelPage from './pages/modelPage'
import CreditPage from './pages/creditDetailPage'
import CreateCredit from './pages/createPages/createCredit'
import SectionsTable from './components/tables/sectionsTable'
import CreateSectionPage from './pages/createPages/createSection'
import SectionPage from './pages/sectionPage'
import TagsPage from './pages/tagsPage'
import TagPage from './pages/tagPage'
import CreateTagPage from './pages/createPages/createTag'
import ExploreRowsPage from './pages/exploreRowsPage'
import ExploreRowPage from './pages/exploreRowPage'
import CreateExploreRowPage from './pages/createPages/createExploreRow'
import ExplorePageManagement from './pages/explorePageManagement'
import SystemTable from './components/tables/systemTable'
import SystemPage from './pages/systemPage'
import CreateSystemPage from './pages/createPages/createSystem'
import ContentTable from './components/tables/contentTable'
import ContentPage from './pages/contentPage'
import ContentDetailPage from './pages/contentDetailPage'
import CreateContentPage from './pages/createPages/createContent'
import RevenueCatProductsPage from './pages/revenueCatProductsPage'
import CreateRevenueCatProduct from './pages/createPages/createRevenueCatProduct'
import RevenueCatProductDetailPage from './pages/revenueCatProductDetailPage'
import RevenueCatConfigPage from './pages/revenueCatConfigPage'
import { AuthProvider, useAuth } from './context/AuthContext'


function AppContent() {
  const { isLoggedIn } = useAuth();
  const [collapsed, setCollapsed] = useState(false)
  const [marginRight, setMarginRight] = useState(getMarginRight())

function getMarginRight() {
  const width = window.innerWidth
  if (width < 576) return '16px'    
  if (width < 768) return '32px'    
  if (width < 992) return '60px'   
  return '110px'                    
}

useEffect(() => {
  const handleResize = () => {
    setMarginRight(getMarginRight())
  }

  window.addEventListener('resize', handleResize)
  return () => window.removeEventListener('resize', handleResize)
}, [])

  return (
    <>
      {isLoggedIn ? (
        <>
          <NavBar />

          <SideMenu collapsed={collapsed} setCollapsed={setCollapsed} />
        
          <div
            className="p-4"
            style={{
              marginLeft: '160px',
              marginTop: '36px',
              transition: 'margin-left 0.3s ease'
            }}
          >
            <Routes>
                <Route path="/users" element={<UserTable />} />
                <Route path="/models" element={<ModelTable />} />
                <Route path="/models/:id" element={<SingleModelPage />} />
                <Route path="/styles" element={<StyleTable />} />
                <Route path="/prompts" element={<PromptTable />} />
                <Route path="/prompts/create" element={<CreatePromptPage />} />
                <Route path="/prompts/:id" element={<PromptPage />} />
                <Route path="/categories" element={<CategoryTable />} />
                <Route path="/styles/create" element={<CreateStylePage />} />
                <Route path="/styles/:id" element={<StylePage />} />
                <Route path="/sections" element={<SectionsTable />} />
                <Route path="/sections/create" element={<CreateSectionPage />} />
                <Route path="/sections/:id" element={<SectionPage />} />
                <Route path="/users/:id" element={<SingleUserPage />} />
                <Route path="/sets/:id" element={<SingleSetPage />} />
                <Route path="/sets" element={<SetTable />} />
                <Route path="/credits/:id" element={<CreditPage />} />
                <Route path="/credits/create/:id" element={<CreateCredit />} />
                <Route path="/tags" element={<TagsPage />} />
                <Route path="/tags/create" element={<CreateTagPage />} />
                <Route path="/tags/:id" element={<TagPage />} />
                <Route path="/explore-management" element={<ExplorePageManagement />} />
                <Route path="/explore-rows" element={<ExploreRowsPage />} />
                <Route path="/explore-rows/create" element={<CreateExploreRowPage />} />
                <Route path="/explore-rows/:id" element={<ExploreRowPage />} />
                <Route path="/content" element={<ContentPage />} />
                <Route path="/content/create" element={<CreateContentPage />} />
                <Route path="/content/:id" element={<ContentDetailPage />} />
                <Route path="/system" element={<SystemTable />} />
                <Route path="/system/create" element={<CreateSystemPage />} />
                <Route path="/system/:id" element={<SystemPage />} />
                <Route path="/revenuecat-products" element={<RevenueCatProductsPage />} />
                <Route path="/revenuecat-products/create" element={<CreateRevenueCatProduct />} />
                <Route path="/revenuecat-products/:id" element={<RevenueCatProductDetailPage />} />
                <Route path="/revenuecat-config" element={<RevenueCatConfigPage />} />
                <Route path="/" element={<HomePage />} />
              </Routes>
        </div>
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </>
  )
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  )
}
